module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460952.9eeb09e6.png";